import './MainLayout.css';
const MainLayout = () => {

    return (
        <div className={'wrapper'}>
            <div className={'content'}>
                <div className={'centered'}>
                    <div className={'dividerWrapper'}>
                        <div className={'divider'}/>
                    </div>
                    <img className={'imageLogo'} src={'images/logo_transparant.png'} alt={""}/>
                    <div className={'dividerWrapper'}>
                        <div className={'divider'}/>
                    </div>
                    <div className={'subText'}>
                        <h3>Building custom software solutions for your business</h3>
                    </div>
                </div>
            </div>
            <div className={'info'}>
                <div className={'infoContent'}>
                    <h3>WB Software Services BV</h3>
                    <p className={'address'}>
                        Zavelvennestraat 174<br/>
                        3500 Hasselt<br/>
                        BE 0786.547.858<br/>
                        info@wbsoftwareservices.be
                    </p>
                </div>
            </div>
            <div className={'footer'}>
                <div className={'footerContent'}>
                    © {new Date().getFullYear()} WB SOFTWARE SERVICES BV
                </div>
            </div>
        </div>
    );
}

export default MainLayout;